import { useMutation } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import { message } from 'antd';

import { KimLhcService } from '@/infra/services/kim-lhc';

interface DownloadKimLhcPDFParams {
	organization_id: string;
	company_id: string;
	locale: string;
	id: string;
}

const Service = KimLhcService.getInstance();

export const useDownloadKimLhcPDF = () => {
	return useMutation({
		mutationFn: async (params: DownloadKimLhcPDFParams) => Service.downloadPDF(params),
		onSuccess: (data) => {
			let archive = document.createElement('a');
			archive.target = '_blank';
			archive.href = data.url;
			archive.click();
			archive.remove();
		},
		onError: () => {
			message.error(I18n.get('Failed to generate the report'));
		}
	});
};
